import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { TrainingsList, TrainingGuide } from './pages';

import AppLayout from './pages/AppLayout/AppLayout';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: '/:brand',
        element: <TrainingsList />,
      },
      {
        path: '/:brand/trainings/:trainingId/:actionType',
        element: <TrainingGuide />,
        errorElement: <TrainingsList />,
      },
    ],
  },
]);

export const Router: React.FC = () => {
  return <RouterProvider router={router} />;
};
